<template>
  <v-container fluid class="pa-6 pa-md-8">
    <div class="page-head d-flex flex-wrap align-center justify-space-between">
      <div>
        <h1 class="page-head__title">Staff</h1>
        <p class="page-head__sub">Manage staff members and their access.</p>
      </div>
      <v-btn
        :to="{ name: 'admin.staffs.add' }"
        color="primary"
        depressed
        class="text-none add-btn"
      >
        <v-icon small left>mdi-plus</v-icon>
        Add New Staff
      </v-btn>
    </div>

    <div class="toolbar d-flex align-center mb-4">
      <v-text-field
        outlined
        dense
        rounded
        hide-details
        prepend-inner-icon="mdi-magnify"
        placeholder="Search staff…"
        v-model="search"
        color="primary"
        class="toolbar__search"
      />
    </div>

    <v-data-table
      :headers="headers"
      :items="staffList"
      :loading="pageLoading"
      :server-items-length="paginate.total"
      :options.sync="options"
      class="data-table"
      loading-text="Loading… Please wait"
      :search="search"
      :footer-props="{ itemsPerPageOptions: [10, 15, 20] }"
    >
      <template #item.avatar="{ item }">
        <v-avatar size="36" class="cell-avatar">
          <span>{{ item.name | firstLetterFunction }}</span>
        </v-avatar>
      </template>
      <template #item.name="{ item }">
        <span class="cell-strong text-capitalize">{{ item.name }}</span>
      </template>
      <template #item.accountNumber="{ item }">
        <span class="tabular">{{ item.accountNumber }}</span>
      </template>
      <template #item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              :to="{
                name: 'admin.staffs.add',
                query: { id: item._id, action: 'edit' }
              }"
              v-on="on"
              icon
              small
              class="cell-action"
            >
              <v-icon small>mdi-pencil-outline</v-icon>
            </v-btn>
          </template>
          <span>Edit staff member</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              :loading="isLoading"
              :disabled="profile.id === item._id"
              @click="$store.dispatch('staffs/delete', item._id)"
              icon
              small
              class="cell-action cell-action--danger"
            >
              <v-icon small>mdi-trash-can-outline</v-icon>
            </v-btn>
          </template>
          <span>Delete staff member</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <SnackBar
      :showSnackBar="showSnackBar"
      :message="message"
      :status="status"
    />
  </v-container>
</template>

<script>
import { loadComponent } from "@/utils/helpers";
import { mapGetters } from "vuex";
import SnackBarMixins from "../../../../mixins/SnackBarMIxins";
export default {
  name: "AllStaffs",
  data() {
    return {
      options: {},
      search: ""
    };
  },
  components: {
    SnackBar: loadComponent(`component/SnackBar`)
  },

  computed: {
    ...mapGetters({
      allStaff: "staffs/getAllStaffs",
      pageLoading: "getIsPageLoading",
      isLoading: "getIsLoading",
      paginate: "staffs/getPagination",
      profile: "auth/getUserDetails"
    }),
    form() {
      return {
        name: this.name,
        phone: this.phone,
        accountNumber: this.accountNumber
      };
    },
    staffList() {
      return this.allStaff.filter(searchTerm => {
        return (
          searchTerm.name.toLowerCase().indexOf(this.search.toLowerCase()) !==
          -1
        );
      });
    },

    headers() {
      return [
        {
          text: "",
          value: "avatar",
          filterable: false,
          sortable: false
        },
        {
          text: "Staff Name",
          value: "name",
          filterable: true,
          sortable: false
        },
        {
          text: "Account Number",
          value: "accountNumber",
          filterable: false,
          sortable: false
        },
        { text: "Phone", value: "phone", filterable: false, sortable: false },

        {
          text: "Actions",
          value: "actions"
        }
      ];
    }
  },
  filters: {
    status(value) {
      return !value ? "Active" : "Inactive";
    },
    firstLetterFunction(value) {
      return value.charAt(0).toUpperCase();
    }
  },
  mixins: [SnackBarMixins],
  watch: {
    options: {
      handler(value) {
        const { itemsPerPage, page } = value;
        const query = `?page=${page}&size=${itemsPerPage}`;
        this.$store.dispatch("staffs/list", query);
      },
      deep: true
    }
  },

  methods: {},
  created() {
    const query = `?page=1&size=10`;
    this.$store.dispatch("staffs/list", query);
  }
};
</script>

<style scoped>
.toolbar__search {
  max-width: 440px;
  width: 100%;
}
.add-btn {
  border-radius: var(--radius) !important;
  height: 40px !important;
  font-weight: 600;
}
.cell-avatar {
  background: var(--signal-soft);
  color: var(--signal);
  font-size: 13px;
  font-weight: 600;
}
.cell-strong {
  font-weight: 600;
  color: var(--foreground);
}
.cell-action {
  color: var(--muted-foreground) !important;
  margin: 0 2px;
}
.cell-action--danger:hover {
  color: var(--status-failed) !important;
}
</style>
